module.exports = __webpack_public_path__ + "img/George_Collins.897f92d9.png";